const pix = {
  PIX_INVALID_KEY_TYPE: {
    message: 'Tipo de chave PIX inválida',
    field: 'key_type',
    code: 'PIX_1'
  },
  PIX_KEY_INVALID_EMAIL: {
    message: 'O e-mail deve ser válido',
    field: 'key',
    code: 'PIX_2'
  },
  PIX_KEY_INVALID_DOCUMENT: {
    message: 'Documento fornecido não é um CPF nem CNPJ',
    field: 'key',
    code: 'PIX_3'
  },
  PIX_KEY_INVALID_PHONE: {
    message: 'O número de telefone celular deve ser válido',
    field: 'key',
    code: 'PIX_4'
  },
  PIX_KEY_DUPLICATED: {
    message: 'Chave PIX fornecida já existe',
    field: 'key',
    code: 'PIX_5'
  },
  PIX_KEY_INVALID_VERIFICATION_CODE: {
    message: 'Código de verificação da chave PIX inválido',
    field: 'code',
    code: 'PIX_6'
  },
  PIX_MAX_KEY_LIMIT_EXCEEDED: {
    message: 'Limite de chaves PIX excedido (20)',
    field: null,
    code: 'PIX_7'
  },
  INVALID_DATE_FORMAT: {
    message: 'Formato de data inválida',
    field: null,
    code: 'PIX_8'
  },
  MIN_VALUE: {
    message: 'Valor não pode ser R$0,00',
    field: null,
    code: 'PIX_9'
  },
  PAYER_INVALID_PERSON_TYPE: {
    message: 'Tipo do pagador deve ser válido',
    field: 'payer.document',
    code: 'PIX_10'
  },
  PAYER_INVALID_DOCUMENT: {
    message: 'Documento do pagador não é um CPF nem CNPJ',
    field: 'payer.document',
    code: 'PIX_11'
  },
  PAYER_INVALID_NAME: {
    message: 'Nome do pagador deve ser válido',
    field: 'payer.name',
    code: 'PIX_12'
  },
  PAYER_INVALID_EMAIL: {
    message: 'Email do pagador deve ser válido',
    field: 'payer.email',
    code: 'PIX_13'
  },
  PAYER_INVALID_PHONE: {
    message: 'O número de telefone do pagador deve ser válido',
    field: 'payer.phone',
    code: 'PIX_14'
  },
  PIX_KEY_NOT_FOUND: {
    message: 'Chave PIX não encontrada',
    field: 'pix_key_id',
    code: 'PIX_15'
  },
  UNABLE_TO_SEND_PIX_TO_SALARY_ACCOUNT: {
    message: 'Não é possível realizar PIX para conta salário',
    field: null,
    code: 'PIX_16'
  },
  QRCODE_INVALID_DATE: {
    message: 'Data inválida',
    field: null,
    code: 'PIX_17'
  },
  PIX_KEY_IN_CLAIM_PROCESS: {
    message:
      'Esta chave já está cadastrada e encontra-se em processo de reivindicação. Não será possível cadastra-la até que o processo seja concluído',
    field: null,
    code: 'PIX_18'
  },
  CANT_DELETE_KEYS_IN_CLAIM_PROCESS: {
    message: 'Não é possível excluir chaves em processo de reivindicação. Aguarde até que o processo seja concluído',
    field: null,
    code: 'PIX_19'
  },
  INVALID_STATUS_TO_START_A_CLAIM_PROCESS: {
    message: 'Status da chave não permite iniciar um processo de reivindicação',
    field: null,
    code: 'PIX_20'
  },
  INVALID_STATUS_TO_CANCEL_THE_CLAIM_PROCESS: {
    message: 'Status da chave não permite cancelar o processo reivindicação',
    field: null,
    code: 'PIX_21'
  },
  INVALID_STATUS_TO_CONFIRM_THE_CLAIM_PROCESS: {
    message: 'Status da chave não permite confirmar o processo reivindicação',
    field: null,
    code: 'PIX_22'
  },
  CLAIM_ALREADY_EXISTS_FOR_KEY: {
    message: 'Já existe um processo de reivindicação em andamento para esta chave',
    field: null,
    code: 'PIX_23'
  }
};

module.exports = pix;
